import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { RffFieldProps } from '../FieldProps';
import { FormItem } from './FormItem';
import { InputClassNameProp } from '../types';
import { IProps } from '../../common/props';
import { FieldValidator } from 'final-form';

type Props = {
  name: string;
  input: React.ComponentType<any>;
  label: React.ReactNode;
  inlineValidation?: boolean;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  validateWarning?: FieldValidator<any>;
} & RffFieldProps &
  InputClassNameProp &
  IProps;

export const Base = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      input: InputComponent,
      type,
      validateWarning,
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      onChange: customOnChange,
      required,
      disabled,
      readOnly,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            return (
              <InputComponent
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
